// best seller
$(".testimonial-row-1").slick({
  infinite: true,
  slidesToShow: 2,
  autoplay: false,
  dots: true,
  prevArrow:
    '<img class="prod_slider_prev" src="https://cdn.shopify.com/s/files/1/0792/1962/2236/files/round-cir-l.svg?v=1700676531" alt="img">',
  nextArrow:
    '<img class="prod_slider_next" src="https://cdn.shopify.com/s/files/1/0792/1962/2236/files/round-cir-r.svg?v=1700676530" alt="img">',
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 375,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
  ],
});
